import React, { useEffect, useState } from "react";
import {
  getDealLostReasons,
  createDealLostReason,
  updateDealLostReason,
  deleteDealLostReason,
} from "../api";

export default function DealLostReasons() {
  const [reasons, setReasons] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [reasonName, setReasonName] = useState("");
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    loadReasons();
  }, []);

  async function loadReasons() {
    try {
      const res = await getDealLostReasons();
      setReasons(res.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function saveReason() {
    if (!reasonName.trim()) return;

    try {
      if (editingId) {
        await updateDealLostReason(editingId, reasonName);
      } else {
        await createDealLostReason(reasonName);
      }

      await loadReasons();

      setReasonName("");
      setEditingId(null);
      setShowModal(false);
    } catch (err) {
      console.log(err);
    }
  }

  async function removeReason(id) {
    if (!window.confirm("Delete this reason?")) return;

    try {
      await deleteDealLostReason(id);
      await loadReasons();
    } catch (err) {
      console.log(err);
    }
  }

  return (
    <div style={{ padding: "30px" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2>Deal Lost Reasons</h2>

        <button
          onClick={() => {
            setEditingId(null);
            setReasonName("");
            setShowModal(true);
          }}
          style={{
            padding: "10px 20px",
            background: "#16a34a",
            color: "#fff",
            border: "none",
            borderRadius: "8px",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          + Add Reason
        </button>
      </div>

      <table
        border="1"
        cellPadding="16"
        style={{
          width: "100%",
          borderCollapse: "collapse",
          marginTop: "20px",
        }}
      >
        <thead>
          <tr>
            <th>ID</th>
            <th>Reason</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
                      {reasons.map((reason) => (
            <tr key={reason.id}>
              <td>{reason.id}</td>

              <td>{reason.reason}</td>

              <td>
                <button
                  onClick={() => {
                    setEditingId(reason.id);
                    setReasonName(reason.reason);
                    setShowModal(true);
                  }}
                  style={{
                    background: "#2563eb",
                    color: "#fff",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Edit
                </button>
              </td>

              <td>
                <button
                  onClick={() => removeReason(reason.id)}
                  style={{
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    padding: "8px 18px",
                    borderRadius: "8px",
                    cursor: "pointer",
                  }}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {showModal && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,.35)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: 400,
              background: "#fff",
              padding: 25,
              borderRadius: 10,
            }}
          >
            <h3>
              {editingId
                ? "Edit Deal Lost Reason"
                : "Add Deal Lost Reason"}
            </h3>

            <input
              value={reasonName}
              onChange={(e) => setReasonName(e.target.value)}
              placeholder="Reason"
              style={{
                width: "100%",
                padding: 10,
                marginTop: 15,
                marginBottom: 20,
              }}
            />

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 10,
              }}
            >
              <button
                onClick={() => {
                  setShowModal(false);
                  setEditingId(null);
                  setReasonName("");
                }}
              >
                Cancel
              </button>

              <button
                onClick={saveReason}
                style={{
                  background: "#16a34a",
                  color: "#fff",
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "8px",
                  cursor: "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}